
(() => {
  'use strict';

  const GIFT_VARIANT_ID = 67633375772835;

  const BOX_OF_6 = new Set([
    43907956670627,
    43253221621923,
    43974331662499,
    43974141345955,
    43955667599523,
    43974077907107,
    42118006538403,
    42118012076195,
    43955643056291,
    43974348964003,
    43276096110755,
    67769909117091 // Pecans Brookies - Box of 6
  ]);

  const BOX_OF_16 = new Set([
    42118002835619,
    43253221589155,
    43974331629731,
    43966618534051,
    43955667632291,
    42118013780131,
    42118006571171,
    42118012108963,
    43955643089059,
    43974348996771,
    43199808962723,
    67769909149859 // Pecans Brookies - Box of 16
  ]);

  const root = window.Shopify?.routes?.root || '/';
  const form = document.getElementById('BrookieCartForm');

  if (form && form.dataset.brookieSyncReady === 'true') {
    return;
  }

  if (form) {
    form.dataset.brookieSyncReady = 'true';
  }

  let busy = false;
  let syncPromise = null;

  async function cartRequest(endpoint, options = {}) {
    const response = await fetch(root + endpoint, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {})
      }
    });

    if (!response.ok) {
      throw new Error(`Shopify cart request failed: ${endpoint}`);
    }

    return response.json();
  }

  async function getCart() {
    return cartRequest('cart.js');
  }

  function requiredGiftQuantity(cart) {
    return cart.items.reduce((total, item) => {
      const id = Number(item.variant_id);

      if (id === GIFT_VARIANT_ID) return total;

      if (BOX_OF_6.has(id)) {
        return total + item.quantity;
      }

      if (BOX_OF_16.has(id)) {
        return total + item.quantity * 2;
      }

      return total;
    }, 0);
  }

  async function performGiftSync() {
    let cart = await getCart();

    let gifts = cart.items.filter(
      item => Number(item.variant_id) === GIFT_VARIANT_ID
    );

    const required = requiredGiftQuantity(cart);

    // Remove gifts if no qualifying boxes remain.
    if (required === 0) {
      for (const gift of gifts) {
        await cartRequest('cart/change.js', {
          method: 'POST',
          body: JSON.stringify({
            id: gift.key,
            quantity: 0
          })
        });
      }

      return getCart();
    }

    // Add the free gift if it is missing.
    if (gifts.length === 0) {
      await cartRequest('cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: required,
            properties: {
              _brookie_free_gift: 'true'
            }
          }]
        })
      });

      return getCart();
    }

    // Update the first gift line to the required quantity.
    const firstGift = gifts[0];

    if (firstGift.quantity !== required) {
      await cartRequest('cart/change.js', {
        method: 'POST',
        body: JSON.stringify({
          id: firstGift.key,
          quantity: required
        })
      });
    }

    // Remove duplicate gift lines.
    cart = await getCart();

    gifts = cart.items.filter(
      item => Number(item.variant_id) === GIFT_VARIANT_ID
    );

    for (const gift of gifts.slice(1)) {
      await cartRequest('cart/change.js', {
        method: 'POST',
        body: JSON.stringify({
          id: gift.key,
          quantity: 0
        })
      });
    }

    return getCart();
  }

  // Prevent simultaneous sync operations from conflicting.
  async function syncGift() {
    if (syncPromise) {
      await syncPromise;
      return getCart();
    }

    syncPromise = performGiftSync();

    try {
      return await syncPromise;
    } finally {
      syncPromise = null;
    }
  }

  // Make the gift sync function available to the Side Cart.
  window.syncBrookieGift = syncGift;

  // Detailed Cart: handle the Update Cart form.
  if (form) {
    form.addEventListener('submit', async event => {
      if (busy) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      busy = true;

      const submitButton = form.querySelector('[name="update_cart"]');

      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        const inputs = form.querySelectorAll(
          'input[name^="updates["]'
        );

        const updates = {};

        inputs.forEach(input => {
          const row = input.closest('[data-line-key]');

          if (!row) return;

          updates[row.dataset.lineKey] = Math.max(
            0,
            Math.floor(Number(input.value) || 0)
          );
        });

        if (Object.keys(updates).length > 0) {
          await cartRequest('cart/update.js', {
            method: 'POST',
            body: JSON.stringify({ updates })
          });
        }

        await syncGift();
        window.location.reload();

      } catch (error) {
        console.error('[Big Brookie Sync]', error);
        alert('Cart update failed. Please try again.');

        busy = false;

        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  }

  // Detailed Cart: remove qualifying boxes and resync the gift.
  document.addEventListener('click', async event => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const removeLink = target.closest(
      '.product-remove a, a.remove'
    );

    if (!removeLink || !form || !form.contains(removeLink) || busy) {
      return;
    }

    const row = removeLink.closest('[data-line-key]');

    if (!row) return;

    const variantId = Number(row.dataset.variantId);

    if (
      !BOX_OF_6.has(variantId) &&
      !BOX_OF_16.has(variantId)
    ) {
      return;
    }

    event.preventDefault();
    busy = true;

    try {
      const cart = await getCart();

      const item = cart.items.find(
        entry => entry.key === row.dataset.lineKey
      );

      if (item) {
        await cartRequest('cart/change.js', {
          method: 'POST',
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      }

      await syncGift();
      window.location.reload();

    } catch (error) {
      console.error('[Big Brookie Remove]', error);
      alert('Could not remove the box. Please try again.');
      busy = false;
    }
  });

  // Side Cart: intercept quantity changes when the theme exposes
  // ShopifyAPI.changeItem.
  const shopifyAPI = window.ShopifyAPI;

  if (
    shopifyAPI &&
    typeof shopifyAPI.changeItem === 'function' &&
    !shopifyAPI.changeItem._brookieGiftWrapped
  ) {
    const originalChangeItem = shopifyAPI.changeItem;

    const wrappedChangeItem = function(line, quantity, callback) {
      return originalChangeItem.call(
        this,
        line,
        quantity,
        async function(cart) {
          try {
            await syncGift();

            const updatedCart = await getCart();

            if (typeof callback === 'function') {
              callback(updatedCart);
            }
          } catch (error) {
            console.error(
              '[Big Brookie Side Cart Sync]',
              error
            );

            if (typeof callback === 'function') {
              callback(cart);
            }
          }
        }
      );
    };

    wrappedChangeItem._brookieGiftWrapped = true;
    shopifyAPI.changeItem = wrappedChangeItem;
  }

  // Reconcile the gift when the page opens.
  syncGift().catch(error => {
    console.error('[Big Brookie Initial Sync]', error);
  });

})();
